import React, { useState, useEffect } from 'react';
import lib from 'lib/commons';
import ReactTooltip from 'react-tooltip';

const GiftItem = ({
	data,
	accumulation,
	specialExchangeInfo,
	maxStage,
	handleClaim,
}) => {
	const [canClaim, setCanClaim] = useState(0);
	const [totalRound, setTotalRound] = useState(0);

	useEffect(() => {
		if (
			data?.rewards &&
			data?.rewards.length > 1 &&
			accumulation &&
			specialExchangeInfo &&
			maxStage
		) {
			let base = accumulation / maxStage;
			let remain = accumulation % maxStage;
			// let base = accumulation / data?.stage
			let stageCount = 0;
			for (let index = 0; index < data?.rewards.length; index++) {
				const element = data?.rewards[index];

				stageCount += specialExchangeInfo[element?.id]?.count || 0;
			}

			let turn = 0;

			if (remain >= data?.stage) {
				base += 1;
				turn = base - stageCount;

				setCanClaim(Math.floor(turn));
			} else {
				turn = base - stageCount;
				setCanClaim(Math.floor(turn));
			}

			setTotalRound(base);
		}
	}, [data, specialExchangeInfo, accumulation]);

	const isClaimed = (item, stage) => {
		if (specialExchangeInfo && data?.rewards && data?.rewards.length === 1) {
			const rewards = specialExchangeInfo[item?.id];
			let remain = accumulation % maxStage;

			if (remain >= stage && item?.id != 1) {
				return true;
			}

			if (item?.id == 1 && rewards) {
				return true;
			}

			return false;
		} else {
			return false;
		}
	};

	const handleClickItem = (e) => {
		e.preventDefault();
		handleClaim(data, canClaim, totalRound);
	};

	return (
		<a
			href="#"
			className={`gift-item ${data?.rewards.length <= 1 ? 'disabled' : ''}`}
			data-theme="cyan"
			onClick={(e) => handleClickItem(e)}
		>
			{data?.rewards.length > 1 ? (
				<div className="gift-item__dialog long">
					Số lần có thể chọn quà: {canClaim}
				</div>
			) : (
				<>
					{data?.player_type === 'paid' && (
						<div className="gift-item__dialog">
							Nhận 1 lần duy nhất
							<br />
							với lượt quay trả phí
						</div>
					)}
				</>
			)}

			{data?.rewards.map((item, index) => {
				let currentLimit = 0;
				let realLimit = 0;
				let available = 0;
				let history = 0;
				let nextHistory = 0;

				if (item?.round_required) {
					history = specialExchangeInfo[`${item?.id}`]?.count || 0;
					currentLimit = totalRound / item?.round_required;
					realLimit = Math.min(item?.limit, currentLimit);
					available = realLimit - history;
					nextHistory = history + 1;
				}

				return (
					<div
						className={`gift-item__single ${
							isClaimed(item, data?.stage) ? 'claimed' : ''
						}`}
						key={index}
					>
						{item?.image && item?.desc && (
							<div className="gift-item__image">
								<img
									src={item?.image}
									alt={item?.desc}
									data-tip={`${item?.desc} ${
										item?.limit
											? `(Giới hạn: ${item?.limit} ${
													item?.round_required
														? ` - Quà đặc biệt có thể chọn sau ${
																// nextHistory < item?.limit
																// 	?
																lib.formatNumber(
																	nextHistory * maxStage * item?.round_required
																)
																// : lib.formatNumber(
																// 		item?.limit *
																// 			maxStage *
																// 			item?.round_required
																//   )
														  } điểm`
														: ''
											  })`
											: ''
									}`}
									className={`${
										item?.round_required && available < 1 ? 'disabled' : ''
									}`}
								/>
							</div>
						)}
					</div>
				);
			})}
			<div
				className={`gift-item__times ${
					data?.rewards.length > 1 ? 'is-large' : ''
				}`}
			>
				{data?.stage} điểm
				{data?.rewards.length > 1 && ` (Chọn 1 trong ${data?.rewards.length})`}
			</div>
			<ReactTooltip place="top" type="dark" effect="float" html="true" />
		</a>
	);
};

export default GiftItem;
